/*
 * @Description: l3存在顶柜的时候所需要的处理内容
 * @Author: Dai Guo
 * @Date: 2022-05-09 17:13:29
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-06-15 10:22:44
 */
import { Vector3 } from '@babylonjs/core';
import MeshManage from '../meshManage';
import { BASICTYPE_ENUM } from '../utils/enum';
import { CALLOUTMARGIN, DEFAULTSEALPLATEDEPTH, FRAMEDEPTH, TOPFRAME_GROUND, } from '../utils/kitchenConfig';
import BaseLength from './baseLength';
import { getDefaultDoor } from '../utils/renderUtils';
class LengthZTop extends BaseLength {
    // L型顶柜换位置，位置的获取与正常逻辑不一样 转角柜在lengthZ第一个柜体上
    static getSealPlatePos(templateJson, type) {
        var _a, _b, _c, _d, _e;
        const frameLenghth = (_c = (_b = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.length2) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length;
        const otherLenghth = (_e = (_d = templateJson[type]) === null || _d === void 0 ? void 0 : _d.length2) === null || _e === void 0 ? void 0 : _e.otherSealPlateLength;
        // 只要有otherLenghth就在最后一个普通柜后面
        if (otherLenghth) {
            return frameLenghth;
        }
        // 默认返回
        return 1;
    }
    /**
     *
     * @param sealPlateData 补板数据
     * @param preMeshManage 补板在哪一个柜体前面 meshMange
     * @param type 顶柜/地柜
     * @param frameData 补板在哪一个柜体后面 柜体数据
     * @param _this this：添加到模型管理器使用
     * @returns 地柜：补板的meshMange 顶柜：正前方的meshManage
     */
    renderSealPlate(sealPlateData, preMeshManage, type, frameData, _this) {
        var _a, _b;
        if (!sealPlateData.length) {
            return null;
        }
        let sealPlateMesh;
        const { componentBasic: { id } } = frameData;
        let scaleX = 0;
        let scaleY = 0;
        let scaleZ = 0;
        const moveZ = preMeshManage.getModelSize().z / 2;
        let nextMeshManage = null;
        // 获取柜体门板的厚度
        const defalutDoor = getDefaultDoor(_this.templateJson, 'length2', type);
        const defalutDoorMesh = new MeshManage(_this.scene.getMeshByName((_a = defalutDoor === null || defalutDoor === void 0 ? void 0 : defalutDoor.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
        const sealPlatePos = LengthZTop.getSealPlatePos(_this.templateJson, type);
        const drawerDoorDeepSize = ((_b = defalutDoorMesh === null || defalutDoorMesh === void 0 ? void 0 : defalutDoorMesh.getModelSize()) === null || _b === void 0 ? void 0 : _b[sealPlatePos === 1 ? 'z' : 'x'])
            || DEFAULTSEALPLATEDEPTH;
        const defaluFrameData = new MeshManage(_this.scene.getMeshByName(id));
        // 添加到模型管理器，清楚模型时使用
        this.initSealPlate(sealPlateData, _this);
        switch (type) {
            case BASICTYPE_ENUM.top:
                // eslint-disable-next-line no-param-reassign
                _this.sealPlateData = sealPlateData; // 记录补板数据
                sealPlateMesh = new MeshManage(_this.scene.getMeshByName(sealPlateData[0].id));
                sealPlateData.forEach((plate, plateInx) => {
                    var _a, _b, _c;
                    sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                    if (!(sealPlateMesh === null || sealPlateMesh === void 0 ? void 0 : sealPlateMesh.mesh)) {
                        sealPlateMesh = preMeshManage;
                        return;
                    }
                    switch (plateInx) {
                        case 0:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_a = this.sealPlate) === null || _a === void 0 ? void 0 : _a.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, Math.PI / 2, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x,
                                y: TOPFRAME_GROUND(_this.templateJson) - sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z - moveZ - sealPlateMesh.getModelSize().z * 0.5,
                            });
                            break;
                        case 1:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = defaluFrameData.getModelSize().y / sealPlateMesh.getModelSize().y;
                            scaleZ = drawerDoorDeepSize / sealPlateMesh.getModelSize().z;
                            (_b = this.sealPlate) === null || _b === void 0 ? void 0 : _b.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            // 旋转 并添加到旋转管理器
                            this.setMeshRotate(new Vector3(0, Math.PI / 2, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: -FRAMEDEPTH.TOP - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson) - sealPlateMesh.getModelSize().y,
                                z: preMeshManage.mesh.position.z - moveZ - sealPlateMesh.getModelSize().z * 0.5,
                            });
                            // 顶柜的补板，需要返回正面的mesh 补板后面柜体需要移动
                            nextMeshManage = sealPlateMesh;
                            break;
                        case 2:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, Math.PI / 2, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x,
                                y: TOPFRAME_GROUND(_this.templateJson) - preMeshManage.getModelSize().y
                                    + sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z - moveZ - sealPlateMesh.getModelSize().z * 0.5,
                            });
                            break;
                        default:
                            break;
                    }
                });
                return nextMeshManage;
                break;
            default:
                return null;
                break;
        }
    }
    getFramesCalloutLine(position, title) {
        var _a, _b, _c;
        // 柜体顶端距离地面的高度 用于标线的高度
        const topToGround = this.getCalloutLineTopToGround(position);
        // 获取边的长度
        const { length, lengthValue } = this.getLengthByAddAllFrames(position);
        // 获取边的第一个柜子和最后一个柜子的高度
        const { startHeight, endHeight } = this.getCalloutLineHeightLength();
        // 获取柜深
        const calloutLineDepthLength = this.getCalloutLineDepthLength();
        const l2Length = ((_c = (_b = (_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length2) === null || _c === void 0 ? void 0 : _c.length) / 100 || 0;
        /* -----------长度标线----------- */
        // 长度标线的起点
        const startPoint = { x: 0, y: topToGround + CALLOUTMARGIN, z: l2Length };
        // 长度标线的终点
        const endPoint = { x: 0, y: topToGround + CALLOUTMARGIN, z: l2Length - length };
        // 长度标线
        const lengthLine = { startPoint, endPoint };
        /* -----------长度标线----------- */
        /* -----------高度标线1----------- */
        // 长度标线起点的高度标线起点
        const startHeightStartPoint = {
            x: startPoint.x,
            y: this.getCalloutLineHeightHeight(),
            z: startPoint.z + CALLOUTMARGIN,
        };
        // 长度标线起点的高度标线终点
        const startHeightEndPoint = {
            x: startHeightStartPoint.x,
            y: startHeightStartPoint.y + startHeight,
            z: startHeightStartPoint.z,
        };
        // 长度标线起点的高度标线
        const startHeightLine = {
            startPoint: startHeightStartPoint,
            endPoint: startHeightEndPoint,
        };
        /* -----------高度标线1----------- */
        /* -----------高度标线2----------- */
        const endHeightStartPoint = {
            x: endPoint.x,
            y: this.getCalloutLineHeightHeight(),
            z: endPoint.z - CALLOUTMARGIN,
        };
        const endHeightEndPoint = {
            x: endHeightStartPoint.x,
            y: endHeightStartPoint.y + endHeight,
            z: endHeightStartPoint.z,
        };
        const endHeightLine = {
            startPoint: endHeightStartPoint,
            endPoint: endHeightEndPoint,
        };
        /* -----------高度标线2----------- */
        /* -----------深度标线1----------- */
        // 长度标线起点的深度标线起点（长度标线起点的高度标线起点）
        const startDepthStartPoint = startHeightStartPoint;
        // 长度标线终点的深度标线起点
        const startDepthEndPoint = {
            x: startDepthStartPoint.x - calloutLineDepthLength,
            y: startDepthStartPoint.y,
            z: startDepthStartPoint.z,
        };
        // 长度标线终点的深度标线
        const startDepthLine = {
            startPoint: startDepthStartPoint,
            endPoint: startDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        /* -----------深度标线2----------- */
        // 长度标线终点的深度标线起点（长度标线终点的高度标线起点）
        const endDepthStartPoint = endHeightStartPoint;
        // 长度标线终点的深度标线起点
        const endDepthEndPoint = {
            x: endDepthStartPoint.x - calloutLineDepthLength,
            y: endDepthStartPoint.y,
            z: endDepthStartPoint.z,
        };
        // 长度标线终点的深度标线
        const endDepthLine = {
            startPoint: endDepthStartPoint,
            endPoint: endDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        const calloutLinesArr = [];
        calloutLinesArr.push({
            type: 'length', line: lengthLine, value: lengthValue, title: title || 'L2',
        });
        calloutLinesArr.push({
            type: 'startHeight', line: startHeightLine, value: startHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'endHeight', line: endHeightLine, value: endHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'startDepth', line: startDepthLine, value: calloutLineDepthLength,
        });
        calloutLinesArr.push({
            type: 'endDepth', line: endDepthLine, value: calloutLineDepthLength,
        });
        return calloutLinesArr;
    }
}
export default LengthZTop;
